exports = module.exports = require("../../../../_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cube-slide-item{float:left;box-sizing:border-box;height:100%;width:100%}.cube-slide-item>a{overflow:hidden;text-decoration:none}.cube-slide-item>a,.cube-slide-item>a>img{display:block;height:100%}", ""]);

// exports
